import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FormModal, FormInput, Table } from '../../../../onestep-library/BaseUI'
import { moneyize } from '../../../../onestep-library/TextPresenters/'
import moment from 'moment'
import { updatePendingInvoice, deletePendingInvoice } from './actions'
import { injectStripe } from 'react-stripe-elements'
import ChargeListing from './components/ChargeListing'

function EditPendingInvoice(props) {
  const dispatch = useDispatch()
  const { organization, resident, editPendingInvoiceForm } = useSelector(state => state)
  const { ui, email, recurring_charge_id, description, amount, issued_at, balance, errors,
    charges = [], invoice_client, id, paid_amount, due_days_after_invoice, due_date, is_stripe, receipt_email, receipt_note, email_receipt_to_payer } = editPendingInvoiceForm
  const { show, is_submitting, is_deleting } = ui
  const updateEditPendingInvoiceField = (payload) => dispatch({ type: 'UPDATE_EDIT_PENDING_INVOICE_FIELD', payload })

  function onClose() {
    dispatch({
      type: 'RESET_EDIT_PENDING_INVOICE',
      payload: { show: false }
    })
  }

  function onValidateRequiredFields() {
    return (
      description.length > 0 &&
      String(amount.length) > 0 &&
      ((invoice_client == 'yes' && email.length > 0) || invoice_client == 'no')
    )
  }

  function onSubmit() {
    onClose()
  }

  function onDelete() {
    dispatch(deletePendingInvoice())
  }

  function onErrors() {

  }

  function handleChangeInvoiceClient(e) {
    updateEditPendingInvoiceField({
      invoice_client: e.value,
      email: e.value == 'yes' ? email : ''
    })
  }

  useEffect(() => {
    updateEditPendingInvoiceField({
      invoice_client: !!email ? 'yes' : 'no',
      email_receipt_to_payer: !!receipt_email ? 'yes' : 'no',
    })
  }, [id])

  return (
    <FormModal
      show={show}
      size="lg"
      title={`${description}`}
      isSubmitting={is_submitting}
      isDeleting={is_deleting}
      submitButtonLabel={`Done`}
      showCancel={false}
      deleteButtonLabel='Void'
      errors={errors}
      validationMessage={`${invoice_client == 'yes' ? 'Client Email, Memo, ' : 'Memo'} and Amount Invoiced Fields Are Required`}
      handleClose={onClose}
      handleValidateRequiredFields={onValidateRequiredFields}
      handleSubmit={onSubmit}
      handleDelete={onDelete}
      handleErrors={onErrors}>
      <div className="pb-3">
        {is_stripe && <div className="pb-1"><div className="badge bg-secondary">STRIPE</div></div>}
        <i>
          You cannot edit invoices. If you wish to modify this invoice, you will have to void this invoice and create a new one with modified information.
        </i>
      </div>
      <FormInput
        label="Created On"
        value={moment(issued_at).format("MMMM D, YYYY")}
        disabled />
      <FormInput
        label="Due On"
        value={moment(due_date).format("MMMM D, YYYY")}
        disabled />
      <FormInput
        label="Memo"
        value={description}
        handleChange={(description) => updateEditPendingInvoiceField({ description })}
        disabled />
      <FormInput
        label="Amount Due"
        disabled
        value={moneyize(amount - paid_amount)} />
      <FormInput
        label=" Would you like to email the client a copy of the invoice?"
        type="select"
        options={[{ label: 'Yes', value: 'yes' }, { label: 'No', value: 'no' }]}
        value={invoice_client == 'yes' ? { label: 'Yes', value: 'yes' } : { label: 'No', value: 'now' }}
        handleChange={(e) => handleChangeInvoiceClient(e)}
        disabled />
      {
        invoice_client == 'yes' &&
        <FormInput
          label="Client Email"
          value={email}
          placeholder="Enter client email"
          handleChange={(email) => updateEditPendingInvoiceField({ email })}
          disabled />
      }
      {
        invoice_client == 'yes' &&
        <FormInput
          label="Invoice note"
          value={receipt_note}
          handleChange={(receipt_note) => updateEditPendingInvoiceField({ receipt_note })}
          disabled />
      }
      {
        email_receipt_to_payer == 'yes' &&
        <FormInput
          disabled
          label="Receipt emailed to:"
          value={receipt_email}
          placeholder="Enter client email"
          handleChange={(receipt_email) => updateEditPendingInvoiceField({ receipt_email })} />
      }
      {charges.length > 0 &&
        <div>
          <div className="mb-2">Processed Charges</div>
          <Table
            columnNames={[`Processed On`, "Paid On", "Amount", "Payment Method", 'Memo', ""]}
            rows={charges}
            Row={ChargeListing}
            zeroCaseMessage="No Invoices" />
        </div>
      }
    </FormModal>
  )
}

export default EditPendingInvoice